var _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 42,
    viewBox: "0 0 72 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 22.5,
    x2: 72,
    y2: 22.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.46582 22.24C5.42257 20.2667 11.3825 20.1023 13.7428 20.2667L21.4878 22.24L23.4793 26.68L24.807 20.2667L27.905 38.0267L30.3391 36.0533H34.3222L37.4202 40L39.8543 34.08L42.731 36.0533L43.6161 22.24H47.1567L49.1482 26.68L50.9185 8.42667L53.7952 10.4L56.6719 3L60.4337 10.4",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphHome);
export default __webpack_public_path__ + "static/media/Graph-home.eeab4879c95aa1fa0e3816196522e045.svg";
export { ForwardRef as ReactComponent };